import store from '@/store'
import Role from '@/utils/role'

const routes = {
  path: '/student',
  redirect: '/student/courses',
  meta: {
    requiresAuth: true,
  },
  component: () => import(/* webpackChunkName: "user-layout" */ '@/layouts/UserLayout'),
  beforeEnter: (to, from, next) => {
    if (store.state.role === Role.STUDENT) {
      next()
    } else {
      next(from.path)
    }
  },
  children: [
    {
      name: 'Student Courses',
      path: 'courses',
      component: () => import('@/views/Student/Courses')
    },
    {
      name: 'Student Qualification',
      path: 'qualification',
      component: () => import('@/views/Student/Qualification/StudentQualifications')
    },
    {
      name: 'StudentCourse',
      path: 'courses/modules/mod',
      component: () => import('@/components/Curso/ShowCurso')
    },
    {
      name: 'StudentCourseModules',
      path: 'courses/modules',
      component: () => import('@/views/Student/Modules')
    },
    {
      name: 'LessonDetail',
      path: 'courses/modules/mod/activity',
      component: () => import('@/components/Leccion/ShowLeccion')
    },
    {
      name: 'ShowQualification',
      path: 'module/qualifications',
      component: () => import('@/views/Student/Qualification/ShowQualifications')
    },
    {
      name: 'ShowModules',
      path: 'showmodules/:id',
      component: () => import('@/views/Student/Qualification/ShowModules')
    },
    {
      name: 'Events',
      path: 'events',
      component: () => import('@/views/Student/Event/EventStudent')
    },
    {
      name: 'SENCEMiddlware',
      path: 'sence-middlware',
      component: () => import('@/components/SENCE/Middlware'),
    },
    {
      name: 'SENCELoginError',
      path: 'sence/login/error',
      component: () => import('@/components/SENCE/ErrorPage'),
      props: { isLogin: true }
    },
    {
      name: 'SENCELogoutError',
      path: 'sence/logout/error',
      component: () => import('@/components/SENCE/ErrorPage'),
      props: { isLogin: false }
    },
    {
      name: 'attendanceShowCourse',
      path: 'attendance/showcourse',
      component: () => import('@/views/Student/Attendance/ShowCourse'),
    },
    {
      name: 'showAttendance',
      path: 'attendance/showattendace',
      component: () => import('@/views/Student/Attendance/Attendance'),
    },
    {
      name: 'perfilStudent',
      path: 'perfiluser',
      component: () => import('@/components/Usuario/Perfil')
    },
    {
      path: '*',
      redirect: 'courses'
    }
  ]
};

export default routes;




// WEBPACK FOOTER //
// ./src/router/studentRoutes.js